import { CaseReducer, PayloadAction } from "@reduxjs/toolkit";

import { IMrnCategoriesData, IGetManyMrnCategoriesParams } from "./interfaces";

export const SLICE_NAME = "mrnCategories";

export type InitialStateType = {
  data: IMrnCategoriesData;
  params: IGetManyMrnCategoriesParams;
};

type MrnCategoriesDataPayload = {
  data: IMrnCategoriesData;
};

type GetManyMrnCategoriesParamsPayload = {
  params: IGetManyMrnCategoriesParams;
};

export type CaseReducers<State> = {
  setParams: CaseReducer<State, PayloadAction<GetManyMrnCategoriesParamsPayload>>;
  setMrnCategories: CaseReducer<State, PayloadAction<MrnCategoriesDataPayload>>;
};
